import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const SIDEBAR_STATE_STORAGE_KEY = "SIDEBAR_EXPANDED";

type SidebarState = {
  expanded: boolean;
  mobileOpen: boolean;
  /**
   * Transient hover state of the collapsed icon rail. Kept in the store (and
   * out of `persist`'s `partialize`) so every consumer of `useSidebar` sees the
   * rail expand while the pointer is over it, without that leaking into the
   * pinned state the user toggles.
   */
  hoverExpanded: boolean;
  setExpanded: (expanded: boolean) => void;
  setMobileOpen: (open: boolean) => void;
  setHoverExpanded: (hoverExpanded: boolean) => void;
};

export const useSidebarStore = create<SidebarState>()(
  devtools(
    persist(
      (set) => ({
        expanded:
          typeof window !== "undefined"
            ? !window.matchMedia("(max-width: 768px)").matches &&
              localStorage.getItem(SIDEBAR_STATE_STORAGE_KEY) !== "false"
            : true,
        mobileOpen: false,
        hoverExpanded: false,
        setExpanded: (expanded) => set({ expanded, hoverExpanded: false }),
        setMobileOpen: (mobileOpen) => set({ mobileOpen }),
        setHoverExpanded: (hoverExpanded) => set({ hoverExpanded }),
      }),
      {
        name: SIDEBAR_STATE_STORAGE_KEY,
        partialize: (s) => ({ expanded: s.expanded }),
      }
    ),
    { name: "SidebarStore" }
  )
);
